import { useRef, useState } from "react";
import Actionbar from "src/components/common/actionbar/Authactionbar";
import { Message } from "src/components/common/form/Message";
import { useMouseContent } from "src/utils/mouse/mouseContent";

import { useSYS4120_R01Store } from "./Store_SYS4120_R01";

import { AgGridReact } from "ag-grid-react";
import { Content_SYS4120_R01 } from "./Content_SYS4120_R01";
import { SYS4120_R01Dto } from "./Dto_SYS4120_R01";
import { Info_SYS4120_R01 } from "./Info_SYS4120_R01";
import { SearchSection_SYS4120_R01 } from "./SearchSection_SYS4120_R01";
import { Table_SYS4120_R01 } from "./Table_SYS4120_R01";

export const Container_SYS4120_R01 = () => {
	
	const { 
		SYS4120_R01Filter, setSYS4120_R01Filter,
		SYS4120_R01PastFilter, setSYS4120_R01PastFilter,
		allCount,
		initData,
	} = useSYS4120_R01Store();

	// leftWidth가 변경될 때 localStorage에 저장

	const RESIZER = {
		code: 'SYS4120_R01',
		type: 'width',
		storageKey: 'SYS4120_R01-split-width',
		min: 5,
		max: 80,
		default: 40
	} as const;
	const gridRef = useRef<AgGridReact<SYS4120_R01Dto>>(null);

	
	const containerRef = useRef<HTMLDivElement>(null);
	const infoRef = useRef<HTMLDivElement>(null);
	const isResizing = useRef(false);

	

	const { 
		splitValue,
		handleMouseDown,
		handleMouseUp
	} = useMouseContent({
		resizer: RESIZER,
		isResizing,
		containerRef,
		infoRef
	});

	const {
		handleExcelClick,
		defaultSYS4120_R01Row,
		fetchData,
		initContainerData,
		handleCreateClick,
		handleDeleteClick,
		handleSaveClick,
	} = Content_SYS4120_R01({
		gridRef,
		containerRef,
		
	});

	return (
	<div className="content-container">
		<Actionbar
			onFetchClick={fetchData}
			onCreateClick={handleCreateClick}
			onDeleteClick={handleDeleteClick}
			onSaveClick={handleSaveClick}
			onExcelClick={handleExcelClick}
			onInitClick={initContainerData}
		/>
		<SearchSection_SYS4120_R01 />
		<div className="flex flex-1 p-[12px] gap-[4px] min-h-0" ref={containerRef}>
			<div className="h-full" style={{ width: `${splitValue}%` }}>
				<Table_SYS4120_R01 gridRef={gridRef} defaultSYS4120_R01Row={defaultSYS4120_R01Row()} />
			</div>
			{/* 리사이저 */}
			<div
				className="w-[6px] bg-gray-100 cursor-col-resize hover:bg-gray-300"
				onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleMouseDown('LR', e.nativeEvent)}
				// 드래그 시작 방지
				onDragStart={(e: React.DragEvent<HTMLDivElement>) => e.preventDefault()}
			/>
			<div className="h-full" style={{ width: `${100 - splitValue}%` }} ref={infoRef}>
				<Info_SYS4120_R01 defaultSYS4120_R01Row={defaultSYS4120_R01Row()} />
			</div>
		</div>
		<Message />
	</div>
	)
}